import moment from 'moment-timezone';

import { timeToTimeString } from './time-to-time-string';

/**
 * Converts time to timestamp for a given date and timezone
 *
 * @param {number} value Time in milliseconds
 * @param {string} date Date in format D-M-YYYY
 * @param {string} timezone Restaurant timezone
 * @param {boolean} addDay Indicate if time for the next day
 * @returns {number} Timestamp for passed date and time
 */
export  function timeToTimestamp(value: number, date: string, timezone: string, addDay = false): number {
  const _date = moment.tz(`${date} ${timeToTimeString(value, timezone)}`, 'D-M-YYYY hh:mm A', timezone);
  if (addDay) {
    _date.add(1, 'day');
  }

  return _date.valueOf();
}
